import React from "react";
import { get, isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faArrowLeft } from "@fortawesome/pro-light-svg-icons";
import { faPhone, faEnvelope } from "@fortawesome/pro-solid-svg-icons";
import { getPathWithParam, MANAGE_MASTERS_ROUTES } from "../../utils";
import { GetInitials, AddToolTip } from "../../components";
const bankAccountTypes = {
  1: "Saving",
  2: "Checking",
};
const RenderMenu = ({
  item,
  menuList,
  selectedMenu,
  details,
  setOpen,
  clearingPartnerAccountId,
  advisorRepresentativeId,
  setOpenPlans,
}) => {
  console.log(details, "details");
  const clearingPartnerAccountDetails =
    clearingPartnerAccountId &&
    get(details, "clearingPartnerListResponses", [])?.find(
      (e) => e.id === clearingPartnerAccountId
    );
  const advisorRepresentativeDetails =
    advisorRepresentativeId &&
    get(details, "advisorRepresentatives", [])?.find(
      (e) => e.id === advisorRepresentativeId
    );
  console.log(details, "pagedetails");
  switch (item) {
    case "clearing-partner-details":
      return (
        <div className="clearing-partner-details-menu">
          <Link
            className="clearing-partner-details-menu-back-button"
            to={MANAGE_MASTERS_ROUTES.CLEARING_PARTNER}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className="clearing-partner-details-menu-back-label">
              Back
            </span>
          </Link>
          <div className="clearing-partner-details-menu-content">
            {!isEmpty(details?.logo) ? (
              <img
                alt=""
                src={details?.logo}
                style={{ width: "90px", height: "74px" }}
                className="img-fluid"
              />
            ) : (
              <GetInitials name={details?.name} />
            )}
            <div className="clearing-partner-name">{details?.name}</div>
            <div className="associated-plans">
              <div className="associated-plans-label" onClick={setOpenPlans}>
                Associated Plans
              </div>
              <div className="associated-plans-number">
                {details?.totalPlans}
              </div>
            </div>
            <div className="clearance-time">
              <div className="clearance-time-label" onClick={setOpen}>
                Clearance Time
              </div>
              {details?.clearanceTimeResponses?.length <= 2
                ? details?.clearanceTimeResponses?.map((item, i) => {
                    return (
                      <div className="clearance-time-number">{item.time}</div>
                    );
                  })
                : details?.clearanceTimeResponses?.map((item, i) => {
                    return i <= 2 ? (
                      <div className="clearance-time-number">{item.time}</div>
                    ) : null;
                  })}{" "}
              {details?.clearanceTimeResponses?.length > 3 &&
                +details?.clearanceTimeResponses?.length - 3}
            </div>
            <div className="contact-details">
              <div className="contact-details-label">Contact Details</div>
              <div className="contact-details-name">{details?.contactName}</div>
              <div className="contact-details-number">
                <FontAwesomeIcon icon={faPhone} />
                <div className="contact-details-number-phone">
                  {details?.contactPhone}
                </div>
              </div>
              <div className="contact-details-number">
                <FontAwesomeIcon icon={faEnvelope} />
                <div className="contact-details-number-phone">
                  {details?.contactEmail}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    case "clearing-partner-account-plan-details":
      return (
        <div className="clearing-partner-account-details-menu">
          <Link
            className="clearing-partner-details-menu-back-button"
            to={`${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS}/${details.id}`}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className="clearing-partner-details-menu-back-label">
              Back
            </span>
          </Link>
          <div className="clearing-partner-account-plan-name-container">
            <div className="heading">Clearing Partner</div>
            <div className="sub-title">{details?.name}</div>
          </div>
          <div className="clearing-partner-account">
            <div className="heading">Clearing Partner Account ID</div>
            <div className="clearing-partner-account-identifier">
              {clearingPartnerAccountDetails?.clearingPartnerId}
            </div>
            <div className="description">
              <AddToolTip name={clearingPartnerAccountDetails?.description}>
                <div className="below-font">
                  {clearingPartnerAccountDetails?.description?.slice(0, 30)}...
                </div>
              </AddToolTip>
            </div>
          </div>
          <div className="bank-details">
            <div className="heading">Bank Name</div>
            <div className="sub-title">
              {clearingPartnerAccountDetails?.bankName}
            </div>

            <div className="heading">Account Number</div>
            <div className="sub-title">
              {clearingPartnerAccountDetails?.accountNumber}
            </div>

            <div className="heading">Account Type</div>
            <div className="sub-title">
              {bankAccountTypes[clearingPartnerAccountDetails?.bankAccountType]}
            </div>

            <div className="heading">Routing Number</div>
            <div className="sub-title">
              {clearingPartnerAccountDetails?.abaRoutingNumber}
            </div>
          </div>
        </div>
      );
    case "advisor-representative-details":
      return (
        <div className="clearing-partner-details-menu">
          <Link
            className="clearing-partner-details-menu-back-button"
            to={MANAGE_MASTERS_ROUTES.ADVISOR}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className="clearing-partner-details-menu-back-label">
              Back
            </span>
          </Link>
          <div className="clearing-partner-details-menu-content">
            {!isEmpty(details?.logo) ? (
              <img
                alt=""
                src={details?.logo}
                style={{ width: "90px", height: "74px" }}
                className="img-fluid"
              />
            ) : (
              <GetInitials name={details?.firmName} />
            )}
            <div className="clearing-partner-name">{details?.firmName}</div>
            <div className="associated-plans">
              <div className="associated-plans-label" onClick={setOpenPlans}>
                Associated Plans
              </div>
              <div className="associated-plans-number">
                {details?.associatedPlansCount}
              </div>
            </div>

            <div className="contact-details">
              <div className="contact-details-label">Contact Details</div>
              {/* <div className="contact-details-name">{(get,"details.contactDetails.email","")}</div> */}
              <div className="contact-details-number">
                <FontAwesomeIcon icon={faPhone} />
                <div className="contact-details-number-phone">
                  {details?.contactDetails?.mobilePhoneNumber}
                </div>
              </div>
              <div className="contact-details-number">
                <FontAwesomeIcon icon={faEnvelope} />
                <div className="contact-details-number-phone">
                  {details?.contactDetails?.email}
                </div>
              </div>
            </div>
            <div className="contact-details">
              <div className="contact-details-label">Advisor Service Type</div>
              {/* <div className="contact-details-name">{(get,"details.contactDetails.email","")}</div> */}
              <div className="contact-details-number">
                <div className="contact-details-number-phone">
                  {details?.advisorServiceType}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    case "advisor-representative-plan-detail":
      return (
        <div className="clearing-partner-account-details-menu">
          <Link
            className="clearing-partner-details-menu-back-button"
            to={`${MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_DETAILS}/${details.id}`}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className="clearing-partner-details-menu-back-label">
              Back
            </span>
          </Link>
          <div className="clearing-partner-account-plan-name-container">
            <div className="heading">Advisor Representative</div>
            <div className="sub-title">
              {advisorRepresentativeDetails?.name}
            </div>
          </div>
          <div className="clearing-partner-account">
            <div className="heading">Advisor Representative Number</div>
            <div className="clearing-partner-account-identifier">
              {advisorRepresentativeDetails?.number}
            </div>
          </div>
        </div>
      );
    default:
      return (
        <ul className="manage-master-menu">
          {menuList.map((item) => {
            const childRoutes = get(item, "childRoutes", []);
            let className =
              selectedMenu.indexOf(item.path) !== -1 ||
              childRoutes.filter((route) => {
                return selectedMenu.indexOf(route) !== -1;
              }).length
                ? "selected"
                : "";

            return (
              <li key={item.path} className={`${className} has-tick`}>
                <FontAwesomeIcon icon={faCheckCircle} size="1x" />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Link
                  to={getPathWithParam({
                    path: item.path,
                    //pathParam: [flow, eligibilityId],
                  })}
                >
                  {item.label}
                </Link>
                {/* <span className="open-rounded-corner-top" />
                        <span className="open-rounded-corner-bottom" /> */}
              </li>
            );
          })}
        </ul>
      );
  }
};

const ManageMasterMenu = ({
  menuList = [],
  selectedMenu,
  innerDetailsFlag,
  details,
  setOpen,
  clearingPartnerAccountId,
  advisorRepresentativeId,
  setOpenPlans,
}) => {
  const menuItem = selectedMenu.split("/")[2];

  return (
    <RenderMenu
      menuList={menuList}
      item={menuItem}
      selectedMenu={selectedMenu}
      details={details}
      advisorRepresentativeId={advisorRepresentativeId}
      clearingPartnerAccountId={clearingPartnerAccountId}
      setOpen={setOpen}
      setOpenPlans={setOpenPlans}
    />
  );
};

export default ManageMasterMenu;
